import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import SportTypeForm from './SportTypeForm';
import { sportTypeIds, sportPreferencePromptStates } from '../../../utils/eventConstants';
import { postSportTypeV2 } from '../../../actions/onboarding-actions';

import styles from '../nuoV2.scss';
import { updateFeedPreferences, markSportPreferencePromptAnswered } from '../../../actions/settings-actions';

const SportType = ({ isFeedPreferenceModal, auth }) => {
    const [showFeedPreferenceModal, setShowFeedPreferenceModal] = useState(true);
    const [error, setError] = useState();
    const dispatch = useDispatch();
    const hasAnsweredSportPreferencePrompt = auth?.user?.sportPreferencePromptState === sportPreferencePromptStates.ANSWERED;

    const handleSubmit = (values) => {
        const payload = {
            memberSports: [],
        };
        if (values.tennis) {
            payload.memberSports.push({ sportTypeId: sportTypeIds.TENNIS });
        }
        if (values.pickleball) {
            payload.memberSports.push({ sportTypeId: sportTypeIds.PICKLEBALL });
        }
        if (payload.memberSports.length) {
            if (isFeedPreferenceModal) {
                dispatch(updateFeedPreferences({
                    showPickleballContent: values.pickleball,
                    showTennisContent: values.tennis,
                }));
                dispatch(markSportPreferencePromptAnswered());
                setShowFeedPreferenceModal(false);
            } else {
                dispatch(postSportTypeV2(payload));
            }
        } else {
            setError('Please select a sport type');
        }
    };
    if (isFeedPreferenceModal && showFeedPreferenceModal && !hasAnsweredSportPreferencePrompt) {
        return (

            <div className={`${isFeedPreferenceModal ? styles.bgContainer : ''}`} data-testid="modal.sport-type">
                <div className={`${styles.pageContent} ${isFeedPreferenceModal ? styles.feedPreferenceModalContainer : ''} `}>
                    <div className={`${styles.title} ${isFeedPreferenceModal ? styles.modalTitle : ''}`} data-testid="nuo-v2.sport-type.title">
                        What sports do you play?
                    </div>
                    <SportTypeForm
                        onSubmit={handleSubmit}
                        error={error}
                        isFeedPreferenceModal={isFeedPreferenceModal}
                        auth={auth}
                        buttonOnClick={() => setShowFeedPreferenceModal(false)}
                    />
                </div>
            </div>
        );
    }
    if (!isFeedPreferenceModal) {
        return (
            <div className={styles.pageContent}>
                <div className={styles.title} data-testid="nuo-v2.sport-type.title">
                    What sports do you play?
                </div>
                <SportTypeForm
                    onSubmit={handleSubmit}
                    error={error}
                />
            </div>
        );
    }
    return null;
};

SportType.propTypes = {
    isFeedPreferenceModal: PropTypes.bool.isRequired,
    auth: PropTypes.instanceOf(Object).isRequired,
};

export default SportType;
